// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.buttonStyleError {
  border: 1px solid #d32f2f !important;
  color: #d32f2f !important;
}

.buttonStylePrimary {
  background: #182250 !important;
}

.buttonStyleSecondary {
  background: #1D1E1D !important;
}

.buttonStyleSuccess {
  background: #03AC55 !important;
}

.buttonStyleNeutral {
  border: 1px solid rgba(0, 0, 0, 0.23) !important;
  color: black !important;
}
.buttonStyleNeutral:hover {
  border: 1px solid #9148A9 !important;
}

.buttonStyleFailed {
  background: #f03800 !important;
}

.buttonStyleBlank {
  background-color: transparent !important;
  border: 0 !important;
}

.bottonStyleWhite {
  background: white !important;
  color: #9148A9 !important;
}`, "",{"version":3,"sources":["webpack://./src/components/custom-button/customButtonStyles.scss"],"names":[],"mappings":"AAAA;EACE,oCAAA;EACA,yBAAA;AACF;;AAEA;EACC,8BAAA;AACD;;AAEA;EACE,8BAAA;AACF;;AAEA;EACE,8BAAA;AACF;;AAEA;EAEE,gDAAA;EAMA,uBAAA;AALF;AACE;EACE,oCAAA;AACJ;;AAKA;EACE,8BAAA;AAFF;;AAKA;EACE,wCAAA;EACA,oBAAA;AAFF;;AAOA;EACE,4BAAA;EACA,yBAAA;AAJF","sourcesContent":[".buttonStyleError {\n  border: 1px solid #d32f2f !important;\n  color: #d32f2f !important;\n}\n\n.buttonStylePrimary {\n background: #182250 !important;\n}\n\n.buttonStyleSecondary {\n  background:#1D1E1D !important;\n}\n\n.buttonStyleSuccess {\n  background: #03AC55 !important;\n}\n\n.buttonStyleNeutral {\n  //background-color: #ffffff !important;\n  border: 1px solid rgba(0, 0, 0, 0.23) !important;\n\n  &:hover {\n    border: 1px solid #9148A9 !important;\n  }\n\n  color: black !important;\n}\n\n.buttonStyleFailed {\n  background: #f03800 !important;\n}\n\n.buttonStyleBlank {\n  background-color: transparent !important;\n  border: 0 !important;\n  //color: black !important;\n}\n\n\n.bottonStyleWhite {\n  background: white !important;\n  color: #9148A9 !important;\n}\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
